import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class ProfessionCardColourful extends BaseModel {
  static override constructorName = 'ProfessionCardColourful'

  id: string = ''
  name: string = ''
  slug: string = ''
  description: string = ''
  'card_image': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.card_image = toCroppedImage(data.card_image)
    }
  }
}

registerModel(ProfessionCardColourful)
